<template>
  <div>
    <div v-if="!errorToShow.show" id="root"></div>
    <v-overlay v-if="overlay" :absolute="absolute">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="11"> {{ $t(`yunoComponent.overlayMessage.${overlayMessage}`) }} </v-col>
        <v-col cols="10">
          <v-progress-linear v-if="progress" :color="color" indeterminate rounded height="10"></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>

    <v-overlay v-if="errorToShow.show" class="align-start" :opacity="1" style="z-index: 1000000" color="white">
      <v-row justify="center" no-gutters style="margin-left: 15%; margin-right: 15%; margin-top: 100px">
        <v-col cols="12" class="d-flex justify-center">
          <div class="prominent-icon-wrapper">
            <div class="prominent-icon-bg" :style="{backgroundColor: errorToShow.textColor}"></div>
            <div class="prominent-icon">
              <v-icon :color="errorToShow.textColor" size="30"> {{ errorToShow.icon }} </v-icon>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <span class="font-weight-bold" style="font-size: 15px; color: #333333"> {{ $t(`yunoComponent.errorMessage.${errorToShow.code}.title`) }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-2">
          <span class="font-weight-medium" style="font-size: 15px; color: #333333"> {{ $t(`yunoComponent.errorMessage.${errorToShow.code}.message`) }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <v-btn class="white--text" elevation="0" rounded large :color="color" style="letter-spacing: normal; font-size: 15px; font-weight: 400" @click="backButtonRedirect(errorToShow.code)">
            {{ $t('yunoComponent.errorBackButton') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import axios from 'axios'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'YunoAPM',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    progress: false,
    overlay: false,
    overlayMessage: 'loading',
    absolute: true,
    flag: 0,

    //errors
    errorCreatePayment: false,
    imageError: false,
    currentErrors: [],
    errorToShow: {
      message: '',
      textColor: '',
      buttonColor: '',
      type: '',
      icon: '',
      backButton: false,
      show: false,
      code: ''
    },
    errorsDict: {
      errorCreatePayment: {
        textColor: '#F57C00',
        buttonColor: '#F57C00',
        type: 'info',
        icon: 'mdi-information',
        backButton: true,
        show: true,
        code: 'ERR_YUNO_METHOD'
      },
      isPayed: {
        textColor: '#F57C00',
        buttonColor: '#F57C00',
        type: 'info',
        icon: 'mdi-information',
        backButton: true,
        show: true,
        code: 'ERR_PAYED'
      },
      hashExpired: {
        textColor: 'red',
        buttonColor: '#E57373',
        type: 'error',
        icon: 'mdi-alert',
        backButton: true,
        show: true,
        code: 'ERR_HASH_EXPIRED'
      },
      rejectedGetBack: {
        backButton: false,
        show: true,
        code: 'REJECTED_GET_BACK'
      }
    }
  }),
  computed: {
    ...mapState([
      'errorHashExpired',
      'is_payed',
      'isHeaders',
      'errorHeaders',
      'color',
      'idSessionHash',
      'x_country',
      'x_commerce',
      'x_customerid',
      'x_channel',
      'x_usrtx',
      'x_api_version',
      'x_language'
    ])
  },
  watch: {
    errorCreatePayment: function () {
      this.currentErrors.push('errorCreatePayment')
      this.postErrorStatus(this.errorsDict['errorCreatePayment'])
      this.selectError()
    },
    errorHashExpired: function () {
      this.currentErrors.push('hashExpired')
      if (!this.errorHeaders && !this.errorMethods && !this.is_payed) {
        this.postErrorStatus(this.errorsDict['hashExpired'])
      }
      this.selectError()
    },
    errorHeaders: function () {
      this.currentErrors.push('errorCreatePayment')
      this.postErrorStatus(this.errorsDict['errorCreatePayment'])
      this.selectError()
    },
    is_payed: function () {
      this.currentErrors.push('isPayed')
      this.selectError()
    },
    // Cuando los headers estén cargados y no se tengan errores, entonces se ejecuta el pago
    isHeaders: function () {
      if (!this.errorHashExpired && !this.errorHeaders && !this.is_payed) {
        this.startPayment()
      }
    },
    x_language: function () {
      this.$i18n.locale = this.x_language?.toLowerCase() || 'es'
    }
  },
  async mounted() {
    this.setIdSessionHash(this.data[1]) // Se obtiene IdSesion del url param
    await this.getHeaders()
  },
  methods: {
    ...mapMutations(['postErrorStatus', 'backButtonRedirect', 'setIdSessionHash', 'getHeaders']),
    handleImageError() {
      this.imageError = true // Marcar que ha ocurrido un error al cargar la imagen
    },
    base64UrlEncode(str) {
      let base64 = btoa(str)
      base64 = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
      return base64
    },
    selectError() {
      if (this.currentErrors.find((errorName) => errorName === 'isPayed')) {
        this.errorToShow = this.errorsDict['isPayed']
      } else if (this.currentErrors.find((errorName) => errorName === 'errorCreatePayment')) {
        this.errorToShow = this.errorsDict['errorCreatePayment']
      } else if (this.currentErrors.find((errorName) => errorName === 'paymentMethodsProblem')) {
        this.errorToShow = this.errorsDict['paymentMethodsProblem']
      } else if (this.currentErrors.find((errorName) => errorName === 'hashExpired')) {
        this.errorToShow = this.errorsDict['hashExpired']
      }
    },
    // Función para realizar un click automático en la ventana de Yuno
    observeButton() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const button = document.evaluate('//button[contains(@class, "yuno-status__button")]', document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue
            if (button) {
              button.click()
              observer.disconnect()
            }
          }
        })
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    },
    async callbackYuno(idSessionHash, currentHeaders, redirectType) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'selected-payment': 'YUNO',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }
        const encodeParams = this.base64UrlEncode(`${idSessionHash}&${currentHeaders.country}&${currentHeaders.commerce}&${currentHeaders.customerid}&${currentHeaders.usrtx}&${redirectType}`)
        const res = await axios.get(`${process.env.VUE_APP_URL_ACL_YUNO}/${encodeParams}`, auth).catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
        })
        return res.data
        // eslint-disable-next-line no-console
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async externalServiceMagento(currentHeaders, paymentMethodType, idSessionHash) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }

        const body = {
          paymentMethodType,
          idSessionHash
        }

        await axios.post(`${process.env.VUE_APP_URL_BFF}/magento/send_order`, body, auth).catch((e) => {
          console.log('Get error ' + e)
        })
        // eslint-disable-next-line no-console
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async createYunoPayment(tokenParam, checkoutParam, customerParam, currentHeaders, idSessionHash, methodtype) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'selected-payment': 'YUNO',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }
        const res = await axios
          .get(`${process.env.VUE_APP_URL_BFF}/session/payment/yuno/${idSessionHash}?methodType=${methodtype}&checkoutSession=${checkoutParam}&token=${tokenParam}&customerId=${customerParam}`, auth)
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.log('Get error ' + e)
          })
        console.log('Respuesta de createPayment', res)
        return res.data
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    //enviar orden para ser validada por el motor de cancelaciones
    async submitOrderCancellation(currentHeaders, paymentMethodType, idSessionHash) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }

        const body = {
          processorName: paymentMethodType,
          idSessionHash
        }

        await axios.post(`${process.env.VUE_APP_URL_BFF}/cancellation`, body, auth)
      } catch (err) {
        console.log('Get error cancellation' + err)
      }
    },
    async createYunoCheckout(currentHeaders, idSessionHash) {
      try {
        const auth = {
          headers: {
            'x-country': currentHeaders.country,
            'x-commerce': currentHeaders.commerce,
            'x-customerid': currentHeaders.customerid,
            'x-channel': currentHeaders.channel,
            'x-usrtx': currentHeaders.usrtx,
            'x-api-version': '1',
            'selected-payment': 'YUNO',
            'Ocp-Apim-Subscription-Key': process.env.VUE_APP_API_KEY
          }
        }
        const res = await axios.get(`${process.env.VUE_APP_URL_BFF}/session/checkout/yuno/${idSessionHash}`, auth).catch((e) => {
          // eslint-disable-next-line no-console
          console.log('Get error ' + e)
        })
        console.log('Respuesta de yunoCheckout', res)
        return res.data
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Get error ' + err)
      }
    },
    async startPayment() {
      this.overlay = true
      this.progress = true

      const idSessionHash = this.idSessionHash
      const paymentMethodType = this.data[0] // Se obtiene paymentMethodType del url param

      const headers = {
        country: this.x_country,
        commerce: this.x_commerce,
        customerid: this.x_customerid,
        channel: this.x_channel,
        usrtx: this.x_usrtx
      }

      const allowedChannels = JSON.parse(process.env.VUE_APP_CANCELLATION_CHANNEL || '[]')

      if (headers.channel === 'WL360') {
        this.externalServiceMagento(headers, paymentMethodType, idSessionHash)
      }
      //enviar orden para ser validad por el motor de cancelaciones
      if (allowedChannels.includes(headers.channel)) {
        this.submitOrderCancellation(headers, paymentMethodType, idSessionHash)
      }
      const responseCheckoutYuno = await this.createYunoCheckout(headers, idSessionHash)

      if (!responseCheckoutYuno) {
        this.errorCreatePayment = true
        this.progress = false
        return
      }

      const checkoutSessionValue = responseCheckoutYuno.yuno.json.payment.checkout.session || responseCheckoutYuno.yuno.json.payment.checkout.checkoutSession
      const customerIdValue = responseCheckoutYuno.yuno.json.payment.checkout.customerId
      const publicApiKey = responseCheckoutYuno.yuno.json.payment.checkout.sdkKey
      const vaultedToken = null

      const yuno = await Yuno.initialize(publicApiKey)
      const vueContext = this
      await yuno.startCheckout({
        checkoutSession: checkoutSessionValue,
        elementSelector: '#root',
        countryCode: headers.country,
        language: this.x_language?.toLowerCase() || 'es',
        vueContext: vueContext,
        showLoading: false,
        /**
         * callback is called when one time token is created,
         * merchant should create payment back to back
         * @param { oneTimeToken: string } oneTimeToken
         * @param { tokenWithInformation: object } tokenWithInformation
         */
        async yunoCreatePayment(oneTimeToken, tokenWithInformation) {
          vueContext.overlay = true
          vueContext.progress = true

          const yunoRes = await vueContext.createYunoPayment(oneTimeToken, checkoutSessionValue, customerIdValue, headers, idSessionHash, paymentMethodType, tokenWithInformation)

          // Si existe yunoRes
          if (yunoRes) {
            if (yunoRes.yuno.json.payment.checkout.sdk_action_required) {
              vueContext.overlayMessage = 'redirectionProcessor'
              await yuno.continuePayment()

              if (paymentMethodType === 'PAYPAL') {
                vueContext.overlayMessage = 'loading'
                vueContext.observeButton()
              }
              setTimeout(() => {
                vueContext.overlay = false
                vueContext.progress = false
              }, 2000)
            }
          }
          // En caso de que no existe yunoRes (no se respondió nada desde acl yuno luego de enviar el pago)
          else {
            vueContext.errorCreatePayment = true
          }
        },
        async yunoPaymentResult(data) {
          vueContext.overlayMessage = 'redirectionStore'
          vueContext.overlay = true
          vueContext.progress = true
          const callback = await vueContext.callbackYuno(idSessionHash, headers, 'RETURN_URL')
          if (callback) {
            window.parent.location = `${callback.url}`
          }
        },
        /**
         * @param { error: 'CANCELED_BY_USER' | any }
         */
        yunoError: async (error, reason) => {
          if (error === 'CANCELED_BY_USER' && !reason) {
            vueContext.overlayMessage = 'redirectionStore'
            vueContext.overlay = true
            vueContext.progress = true
            if (paymentMethodType === 'PAYPAL') {
              const callback = await vueContext.callbackYuno(idSessionHash, headers, 'RETURN_URL')
              if (callback) {
                window.parent.location = `${callback.url}`
              }
            } else {
              this.postErrorStatus(this.errorsDict['rejectedGetBack'])
              this.backButtonRedirect('BACK_PAGE')
            }
          }

          //vueContext.errorCreatePayment = true
          console.log('There was an error', error)
          console.log('Reason', reason?.cause)
        }
      })
      await yuno.mountCheckoutLite({
        paymentMethodType: paymentMethodType,
        vaultedToken: vaultedToken
      })
    }
  }
}
</script>

<style>
.fb-btn.v-btn--outlined {
  border: thin solid;
}

.prominent-icon-wrapper {
  position: relative;
  width: 54px;
  height: 54px;
}

.prominent-icon-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.25;
}

.prominent-icon {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
